import { useGetHighestBid } from '@queries/auctions';
import { getWobbleAnimation } from '@utils/animations';
import { useEffect } from 'react';
import { useAnimatedStyle, useSharedValue } from 'react-native-reanimated';

export default function useAuctionWidgetAnimation() {
  const { data: highestBid } = useGetHighestBid();
  const rotation = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ rotateZ: `${rotation.value}deg` }],
  }));

  useEffect(() => {
    rotation.value = getWobbleAnimation();
  }, [highestBid?.user_id ?? '']);

  return { animatedStyle };
}
